module.exports = __webpack_public_path__ + "img/rubbish-bin.e1b6ac94.svg";